import './style.scss';
import $ from "jquery";
import { gsap } from 'gsap';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

$(document).ready(() => {
    $('.wp-block-krutablocks-latest-posts__gallery-gutenberg .blocks-gallery-grid').flickity({
        pageDots: false,
        prevNextButtons: false,
        groupCells: false,
        contain: true,
        imagesLoaded: true,
        percentPosition: true,
        wrapAround: true,
        autoPlay: false,
    });

    $('.wp-block-krutablocks-latest-posts__gallery-button--prev').on( 'click', function() {
        $('.wp-block-krutablocks-latest-posts__gallery-gutenberg .blocks-gallery-grid').flickity('previous');
    });

    $('.wp-block-krutablocks-latest-posts__gallery-button--next').on( 'click', function() {
        $('.wp-block-krutablocks-latest-posts__gallery-gutenberg .blocks-gallery-grid').flickity('next');
    });

    function buttonFunction() {
        if($(".wp-block-krutablocks-latest-posts").length > 0) {
            $(".wp-block-krutablocks-latest-posts__readmore").each(function() {
                var self = $(this),
                    svg = self.find('.kruta-icons'),
                    text = self.find('p'),
                    tl = gsap.timeline({paused:true});

                tl.fromTo(svg, {rotate:-45}, {duration: 0.3, rotate:0})
                .to(text, {duration: 0.3, x: 4}, "<");

                self.on("mouseenter", () => {
                    tl.play();
                }).on("mouseleave", () => {
                    tl.reverse();
                })
            })
        }
    }
    buttonFunction();

    //QUOTE
    function quoteFunction() {
        if($(".wp-block-krutablocks-latest-posts__article.format-quote").length > 0) {
            $(".wp-block-krutablocks-latest-posts__article.format-quote").each(function() {
                const self = $(this),
                    sign = self.find(".wp-block-krutablocks-latest-posts__quote-gutenberg-icon"),
                    svg = self.find(".kruta-icons");
                    
                sign.on("mousemove", moveIn);
                sign.on("mouseleave", moveOut);

                function moveIn(e){
                    var boundingRect = sign[0].getBoundingClientRect();
                    var relX = e.clientX - boundingRect.left;
                    var relY = e.clientY - boundingRect.top;

                    gsap.to(svg, {
                        duration: 0.3,
                        x: (relX - boundingRect.width/2) / boundingRect.width * 20,
                        y: (relY - boundingRect.height/2) / boundingRect.width * 20,
                        ease: "sine.out",
                        overwrite: "auto"
                    })
                }

                function moveOut(){
                    gsap.to(svg, {
                        duration: 0.3,
                        x: 0,
                        y: 0,
                        overwrite: "auto"
                    })
                }
            })
        }
    }
    quoteFunction();
});